export const CMS_COMPONENT_VIMEO = 'vimeo';
export const VIMEO_VIDEO = 'vimeo-video';

export { initAllCmsVimeoVideos } from './vimeoVideo';
